
/* eslint-disable react/prefer-stateless-function */
/* eslint-disable sonarjs/no-duplicate-string */

import React, { Component } from 'react';
import SVGComponent from '../SVG/SVGComponent';
import { SVG_ICONS, DAYS_SHORT, TENNIS_MAX_NB_MATCH } from '../../constants';
import TeamsPreference from '../../containers/AutoBooking/Soccer/TeamsPreference';

/**
 * @module Modals/AutoBookingModal
 */

export default class AutoBookingModal extends Component {
  constructor(props) {
    super(props);
    let defaultValues = {
      startHour: '00',
      startMin: '00',
      endHour: '00',
      endMin: '00',
      startDay: 1,
      endDay: 1,
      events: [],
      intervalId: null,
    };
    if (props.modalData?.edit) {
      const events = this.updatePreferredTeamsData(structuredClone(props.modalData.selectedInterval.events));
      const selectedIntervalData = {...props.modalData.selectedInterval};
      selectedIntervalData.events = events;
      const startTimeArr = selectedIntervalData.startTime.split(':');
      const startHour = startTimeArr[0];
      const startMin = startTimeArr[1];
      const endTimeArr = selectedIntervalData.endTime.split(':');
      const endHour = endTimeArr[0];
      const endMin = endTimeArr[1];
      defaultValues = {
        ...selectedIntervalData,
        startHour,
        startMin,
        endHour,
        endMin,
      };
    }
    this.state = {
      isStartHourOpen: false,
      isStartMinOpen: false,
      isStartDayOpen: false,
      isEndDayOpen: false,
      isEndHourOpen: false,
      isEndMinOpen: false,
      ...defaultValues,
    };
    let h = 0;
    let m = 0;
    this.hours = [];
    while (h !== 24) {
      const hour = h < 10 ? `0${h}` : h;
      this.hours.push(`${hour}`);
      h += 1;
    }

    this.mins = [];
    while (m !== 60) {
      const min = m < 10 ? `0${m}` : m;
      this.mins.push(`${min}`);
      m += 1;
    }
  }

  /**
   * Reset dropdown teams data when a modal error is thrown
   *
   * @param {object} prevProp
   * @returns {void}
   */
  componentDidUpdate(prevProp) {
    if (this.props.addIntervalError !== prevProp.addIntervalError) {
      const events = this.updatePreferredTeamsData(this.state.events);
      this.setState({
        events,
      });
    }
  }

  updatePreferredTeamsData = (events) => events.map((e) => {
    if (e.preferredTeams) {
      const preferredTeams = [];
      const league = this.props.leagues.find((l) => parseInt(l.id) === parseInt(e.leagueId));
      e.preferredTeams.map((t) => {
        if (typeof t === 'object') return t;
        const team = league.teams.find((x) => parseInt(t) === parseInt(x.id));
        preferredTeams.push(team);
        return team;
      });
      e.preferredTeams = preferredTeams;
    }
    return e;
  });

  getLeagueIndex = (id) => (this.state.events.findIndex((l) => parseInt(l.leagueId) === parseInt(id)
    || parseInt(l.competitionId) === parseInt(id)));

  toggleSelectedLeagues = (league) => {
    const index = this.getLeagueIndex(league.id);
    if (index === -1) {
      const event = this.props.isTennis
        ? {
          competitionId: league.id,
          numMatchesScheduled: 1,
        }
        : {
          leagueId: league.id,
          name: league.name,
          numMatchesScheduled: 1,
          randomMatches: true,
          preferredTeams: null,
        };

      this.state.events.push(event);
    } else {
      this.state.events.splice(index, 1);
    }

    this.setState({
      events: this.state.events,
    });
  };

  changeNoOfMatches = (league, e) => {
    const index = this.getLeagueIndex(league.id);
    const tempEvents = structuredClone(this.state.events);
    tempEvents[index].numMatchesScheduled = e.target.value;
    this.setState({
      events: tempEvents,
    });
  };

  selectRandomMatch = (league) => {
    const index = this.getLeagueIndex(league.id);
    const tempEvents = structuredClone(this.state.events);
    tempEvents[index].randomMatches = !tempEvents[index].randomMatches;
    tempEvents[index].preferredTeams = null;
    this.setState({
      events: tempEvents,
    });
  };

  selectTeamPreference = (league) => {
    const index = this.getLeagueIndex(league.id);
    const tempEvents = structuredClone(this.state.events);
    tempEvents[index]
      .preferredTeams = tempEvents[index].preferredTeams ? null : [];
    tempEvents[index].randomMatches = false;
    this.setState({
      events: tempEvents,
    });
  };

  addTeamPreference = (league) => {
    const index = this.getLeagueIndex(league.id);
    const filteredTeams = this.filteredTeams(league.teams, this.state.events[index].preferredTeams);
    const tempEvents = this.state.events;
    tempEvents[index].preferredTeams.push({ ...filteredTeams[0] });
    this.setState({
      events: tempEvents,
    });
  };

  changeTeam = (league, team, teamIndex) => {
    const index = this.getLeagueIndex(league.id);
    const tempEvents = structuredClone(this.state.events);
    tempEvents[index].preferredTeams[teamIndex] = { ...team };
    this.setState({
      events: tempEvents,
    });
  };

  toggleTeamsDropdown = (league, teamIndex) => {
    const index = this.getLeagueIndex(league.id);
    const tempEvents = structuredClone(this.state.events);
    tempEvents[index].preferredTeams[teamIndex]
      .opened = !tempEvents[index].preferredTeams[teamIndex].opened;
    this.setState({
      events: tempEvents,
    });
  };

  removeTeam = (league, teamIndex) => {
    const index = this.getLeagueIndex(league.id);
    const tempEvents = structuredClone(this.state.events);
    tempEvents[index].preferredTeams.splice(teamIndex, 1);
    this.setState({
      events: tempEvents,
    });
  };

  renderLeagues = () => this.props.leagues.map((league) => {
    const currentLeague = this.state.events.find((l) => (
      parseInt(l.leagueId) === parseInt(league.id)
      || parseInt(l.competitionId) === parseInt(league.id)));
    const maxMatches = this.props.isTennis
      ? TENNIS_MAX_NB_MATCH : Math.floor(league.teams.length / 2);
    return (
      <div className={`row dialog__league-select ${currentLeague ? 'active' : ''}`} key={league.name}>
        <div className="col-sm-7">
          <label className="checkbox">
            <input
              id={`selected-league-${league.name}`}
              onChange={this.toggleSelectedLeagues.bind(this, league)}
              type="checkbox"
              className="league-check"
              checked={!!currentLeague}
            />
            <div className="checkbox__icon m-r-20" />
            <span className="checkbox__label">{league.name}</span>
          </label>
        </div>
        <div className="col-sm-5 dialog__league-option">
          <div className="d-flex align-items-center">
            <input
              id={`numMatches-${league.name}`}
              type="number"
              min="1"
              max={maxMatches}
              className="dialog__league-match m-r-20"
              value={currentLeague ? currentLeague.numMatchesScheduled : 1}
              onChange={this.changeNoOfMatches.bind(this, league)}
              onKeyDown={(event) => {
                event.preventDefault();
              }}
            />
            <span>No. of Match per Round</span>
          </div>
        </div>
        {!this.props.isTennis && (
          <TeamsPreference
            selectTeamPreference={this.selectTeamPreference}
            toggleTeamsDropdown={this.toggleTeamsDropdown}
            addTeamPreference={this.addTeamPreference}
            disabledCheck={this.disabledCheck}
            filteredTeams={this.filteredTeams}
            changeTeam={this.changeTeam}
            removeTeam={this.removeTeam}
            league={league}
            currentLeague={currentLeague}
          />
        )}
        {!this.props.isTennis && (
          <div className="col-sm-5 m-t-20 dialog__league-option">
            <label className="checkbox">
              <input
                type="checkbox"
                onChange={this.selectRandomMatch.bind(this, league)}
                checked={!!(currentLeague && currentLeague.randomMatches)}
              />
              <div className="checkbox__icon m-r-20" />
              <span className="checkbox__label">Random Match</span>
            </label>
          </div>
        )}
      </div>
    );
  });

  disabledCheck = (currentLeague) => {
    if (currentLeague && currentLeague.preferredTeams) {
      const league = this.props.leagues.find((l) => l.id === currentLeague.leagueId);
      if (currentLeague.preferredTeams.length === league.teams.length) {
        return true;
      }
    }
    return false;
  };

  filteredTeams = (allT, preferredT) => {
    const preferredIds = preferredT.map((t) => t.id);
    return allT.filter((team) => !preferredIds.includes(team.id));
  };

  changeState = (field, value) => {
    const newState = this.state;
    newState.isStartHourOpen = false;
    newState.isStartMinOpen = false;
    newState.isStartDayOpen = false;
    newState.isEndDayOpen = false;
    newState.isEndHourOpen = false;
    newState.isEndMinOpen = false;
    newState[field] = value;
    this.setState(newState);
  };

  renderHours = (field) => (
    <div className="dialog__input-dropdown">
      <div className="dialog__input-list">
        {this.hours.map((h) => (
          <div
            className="dialog__input-list-item"
            onClick={this.changeState.bind(this, field, h)}
            key={h}
          >
            {h}
          </div>
        ))}
      </div>
    </div>
  );

  renderMins = (field) => (
    <div className="dialog__input-dropdown">
      <div className="dialog__input-list">
        {this.mins.map((m) => (
          <div
            className="dialog__input-list-item"
            onClick={this.changeState.bind(this, field, m)}
            key={m}
          >
            {m}
          </div>
        ))}
      </div>
    </div>
  );

  renderDays = (field) => (
    <div className="dialog__input-dropdown">
      <div className="dialog__input-list">
        {Object.values(DAYS_SHORT).map((day, i) => (
          <div
            className="dialog__input-list-item"
            onClick={this.changeState.bind(this, field, i + 1)}
            key={day}
          >
            {day}
          </div>
        ))}
      </div>
    </div>
  );

  render() {
    return (
      <div className="modal modal--open">
        <div className="dialog dialog--interval">
          <div className="dialog__heading">
            <span className="dialog__title">Interval</span>
            <SVGComponent
              src={`${SVG_ICONS.utility}#close`}
              className="dialog__close"
              onClick={this.props.closeModal}
            />
          </div>
          <div className="dialog__content">
            {this.props.addIntervalError
              && (
                <div className="dialog__error m-b-35">
                  <div className="dialog__error-txt">
                    {this.props.addIntervalError}
                  </div>
                </div>
              )}
            <div className="dialog__time m-t-15">
              <div className="dialog__row d-flex align-items-center">
                <span className="dialog__row-txt m-r-15">Start</span>
                <div
                  id="startHour_AutobookingModal"
                  className="dialog__input-wrap m-r-15"
                  onClick={this.changeState.bind(this, 'isStartHourOpen', !this.state.isStartHourOpen)}
                >
                  <span className="dialog__input-txt">Hours</span>
                  <div
                    className={`dialog__input dialog__input--select text-center ${this.state.isStartHourOpen ? 'open' : ''}`}
                  >
                    <span>{this.state.startHour}</span>
                  </div>
                  {this.renderHours('startHour')}
                </div>
                <div
                  className="dialog__input-wrap m-r-15"
                  onClick={this.changeState.bind(this, 'isStartMinOpen', !this.state.isStartMinOpen)}
                  id="startMinutes_AutobookingModal"
                >
                  <span className="dialog__input-txt">Minutes</span>
                  <div
                    className={`dialog__input dialog__input--select text-center ${this.state.isStartMinOpen ? 'open' : ''}`}
                  >
                    <span>{this.state.startMin}</span>
                  </div>
                  {this.renderMins('startMin')}
                </div>
                <div
                  id="startDay_AutobookingModal"
                  className="dialog__input-wrap"
                  onClick={this.changeState.bind(this, 'isStartDayOpen', !this.state.isStartDayOpen)}
                >
                  <span className="dialog__input-txt">Days</span>
                  <div
                    className={`dialog__input dialog__input--select text-center ${this.state.isStartDayOpen ? 'open' : ''}`}
                  >
                    <span>{DAYS_SHORT[this.state.startDay]}</span>
                  </div>
                  {this.renderDays('startDay')}
                </div>
              </div>
              <div className="dialog__row d-flex align-items-center m-t-15">
                <span className="dialog__row-txt m-r-15">End</span>
                <div
                  id="endHour_AutobookingModal"
                  className="dialog__input-wrap m-r-15"
                  onClick={this.changeState.bind(this, 'isEndHourOpen', !this.state.isEndHourOpen)}
                >
                  <div
                    className={`dialog__input dialog__input--select text-center ${this.state.isEndHourOpen ? 'open' : ''}`}
                  >
                    <span>{this.state.endHour}</span>
                  </div>
                  {this.renderHours('endHour')}
                </div>
                <div
                  id="endMinute_AutobookingModal"
                  className="dialog__input-wrap m-r-15"
                  onClick={this.changeState.bind(this, 'isEndMinOpen', !this.state.isEndMinOpen)}
                >
                  <div
                    className={`dialog__input dialog__input--select text-center ${this.state.isEndMinOpen ? 'open' : ''}`}
                  >
                    <span>{this.state.endMin}</span>
                  </div>
                  {this.renderMins('endMin')}
                </div>
                <div
                  id="endDay_AutobookingModal"
                  className="dialog__input-wrap"
                  onClick={this.changeState.bind(this, 'isEndDayOpen', !this.state.isEndDayOpen)}
                >
                  <div
                    className={`dialog__input dialog__input--select text-center ${this.state.isEndDayOpen ? 'open' : ''}`}
                  >
                    <span>{DAYS_SHORT[this.state.endDay]}</span>
                  </div>
                  {this.renderDays('endDay')}
                </div>
              </div>
            </div>
            <div className="dialog__sub-title m-t-25">{this.props.isTennis ? 'Competitions' : 'Leagues'}</div>
            <div className="dialog__league">
              {this.renderLeagues()}
            </div>
          </div>
          <div className="dialog__btn-wrap">
            <button
              id="cancel_AutobookingModal"
              type="button"
              className="btn btn-secondary"
              onClick={this.props.closeModal}
            >
              Cancel
            </button>
            <button
              id="save_Autobooking_Modal"
              type="button"
              className="btn btn-primary m-l-10"
              onClick={this.props.addInterval.bind(this, this.state)}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    );
  }
}
